import React from "react";
import PropTypes from "prop-types";

import { RadioButton } from "components/Common/RadioButton";
import { NO_OP_FUNCTION } from "services/helpers";
import "./style.scss";

const RadioButtons = (props) => {
  const {
    name, onChange, onClick, options, checked, uniqueIdentifier
  } = props;

  return (
    <div className="RadioButtons">
      {options.map(curr => (
        <RadioButton
          key={`${curr.value}-${uniqueIdentifier}`}
          id={`${curr.value}-${uniqueIdentifier}`}
          name={name}
          checked={checked === curr.value}
          onChange={onChange}
          onClick={() => {
            onClick(curr.value);
          }}
          label={curr.title}
          description={curr.description}
        />
      ))}
    </div>
  );
};

RadioButtons.propTypes = {
  name: PropTypes.string,
  uniqueIdentifier: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  checked: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func,
  onClick: PropTypes.func
};

RadioButtons.defaultProps = {
  name: "",
  uniqueIdentifier: "",
  onChange: NO_OP_FUNCTION,
  onClick: NO_OP_FUNCTION
};

export default RadioButtons;
